import styled from "styled-components/macro";
import checkmark from "../../../../../components/Icon/checked.svg";

export const IsInvited = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.mgrey};
  padding: 2px 8px;
  border-radius: 20px;

  span,
  p {
    font-size: 10px;
    line-height: unset;
    font-weight: bold;
    color: rgba(24, 31, 56, 0.6);
  }

  > span,
  p {
    letter-spacing: 0.8px;
  }
`;

export const KanbanCardContainer = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.colors.almostWhite};
  box-shadow: rgba(24, 31, 56, 0.05) 0px 2px 2px;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: space-between;
  opacity: 0.5;
  transition: 0.2s ease;
  ${(props) =>
    props.initial &&
    `
opacity: 1; 
transition: .5s ease;`}
  ${(props) =>
    props.active &&
    `
opacity: 1; 
transition: .5s ease; 
`}
${(props) =>
    props.isSelected &&
    `
  background-color: #e7e8ed;
`}
  @media (max-width: 992px) {
    height: 80px;
    margin-bottom: 8px;
  }
`;

export const KanbanContent = styled.div`
  margin-left: 12px;
  margin-top: -3px;
  h3 {
    font-size: 14px;
    text-transform: capitalize;
    color: ${(props) => props.theme.colors.faceliftBlue};
    font-weight: 500;
    margin-bottom: 4px;
  }
  ${(props) =>
    props.isAnonymous &&
    `
h3 {
    filter: blur(5px); 
}
`}
`;

export const KanbanCardAvatar = styled.div`
  height: 37px;
  width: 37px;
  min-width: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.faceliftBlue};
  ${(props) =>
    props.isAnonymous &&
    props.avatar &&
    `
background: url(${props.avatar}) no-repeat top center;
    `};
  background-size: cover;
  border-radius: 50px;
  border: 1px solid ${(props) => props.theme.colors.mgrey};

  @media (min-width: 992px) {
    border-radius: 22px;
  }
`;

export const KanbanContactInfo = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  ${(props) =>
    props.isAnonymous &&
    `
    filter: blur(5px); 
`}
  p {
    font-size: 14px;
    color: ${(props) => props.theme.colors.faceliftBlue};
    opacity: 0.6;
    font-weight: 400;
  }
`;

export const KanbanLinkContainer = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  border-radius: 8px;
  z-index: 9;
  cursor: ${(props) => (props.applicationStatus === "invited" || props.applicationStatus === "rejected" ? "default" : "grab")};
  top: 0;
  left: 0;
`;

export const KanBanSelector = styled.input`
  position: absolute;
  top: 0px;
  right: 0px;
  opacity: ${(props) => (props.$visible ? 1 : 0)};
  cursor: pointer;
  height: 15px;
  width: 15px;
  border: 1px solid rgba(68, 74, 94, 0.6);
  background-color: #fff;
  appearance: none;
  border-radius: 3px;
  transition: 0.1s opacity ease-in-out;

  ${KanbanCardContainer}:hover & {
    opacity: 1;
  }

  &[type="checkbox"]:focus {
    outline: none;
    box-shadow: none;
  }

  &[type="checkbox"]::before {
    position: absolute;
    content: "";
    width: 15px;
    height: 15px;
    opacity: 0;
    transition: 0.1s opacity ease-in-out;
    background-image: url(${checkmark});
    background-size: cover;
    background-position: center;
    left: -1px;
    top: -1px;
  }

  &[type="checkbox"]:checked::before {
    opacity: 1;
  }
`;
